"use client";

import { Api } from "@/Apis";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { LandingSiteTemplateGetDataOutputApiModel } from "@/Apis/ClinicApi";
import useCenterFaqModal from "@/Areas/Center/Pages/CenterFaq/useCenterFaqModal";
import useCenterSeoMetadataModal from "@/Areas/Center/Pages/CenterSeoMetadata/useCenterSeoMetadataModal";
import useCenterSiteTemplatePageModal from "@/Areas/Center/Pages/CenterSiteTemplatePage/useCenterSiteTemplatePageModal";
import useCenterSiteTemplatePageSectionModal from "@/Areas/Center/Pages/CenterSiteTemplatePageSection/useCenterSiteTemplatePageSectionModal";
import { useRouter } from "@/Components/AppProgressBar";
import { Roles } from "@/Helpers";
import { ChildrenOf } from "@/Helpers/CenterOptions.types";
import { IsDevelopment } from "@/Helpers/Environment";
import { useCheckRole, useT } from "@/Hooks";
import {
  EditOutlined,
  FileSearchOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  ReloadOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { FloatButton } from "antd";
import { FC } from "react";

interface TemplateDevToolsProps {
  usageTypeKey: ChildrenOf<"CenterSiteTemplateUsageType">;
  data: LandingSiteTemplateGetDataOutputApiModel;
}

const TemplateDevTools: FC<TemplateDevToolsProps> = ({
  usageTypeKey,
  data,
}) => {
  const router = useRouter();
  const centerSiteTemplatePageModal = useCenterSiteTemplatePageModal();
  const centerSiteTemplatePageSectionModal =
    useCenterSiteTemplatePageSectionModal();
  const centerFaqModal = useCenterFaqModal();
  const centerSeoMetadataModal = useCenterSeoMetadataModal();
  const hasAdminRole = useCheckRole(Roles.Admin);
  const t = useT();

  if (hasAdminRole || IsDevelopment)
    return (
      <FloatButton.Group
        trigger="click"
        type="primary"
        icon={<ToolOutlined />}
        style={{
          insetInlineEnd: 84,
          //     insetInlineEnd: 24, insetBlockStart: 24,
          //     zIndex: 1000,
        }}
      >
        <FloatButton
          icon={<ReloadOutlined />}
          onClick={() => router.refresh()}
          tooltip="رفرش صفحه"
        />
        <FloatButton
          icon={<PlusOutlined />}
          onClick={async () => {
            if (
              await centerSiteTemplatePageSectionModal.showCreate({
                CenterSiteTemplatePageId: data.Id,
              })
            )
              router.refresh();
          }}
          tooltip="افزودن سکشن"
        />
        <FloatButton
          icon={<EditOutlined />}
          onClick={async () => {
            if (
              await centerSiteTemplatePageModal.showEdit(usageTypeKey, data.Id)
            )
              router.refresh();
          }}
          tooltip="ویرایش صفحه"
        />
        <FloatButton
          icon={<FileSearchOutlined />}
          onClick={async () => {
            const { Result } = await Api.CenterSeoMetadata.getList({
              Paging: { PageNumber: 1, RowsCount: 1 },
              TableKey: CenterOptions.Table.CenterSiteTemplatePage.key,
              CenterSiteTemplatePageId: data.Id,
            });
            const seoMetadata = Result?.Paging.Items?.[0];
            const changed = seoMetadata
              ? await centerSeoMetadataModal.showEdit(seoMetadata.Id)
              : await centerSeoMetadataModal.showCreate({
                TableKey: CenterOptions.Table.CenterSiteTemplatePage.key,
                CenterSiteTemplatePageId: data.Id,
                Title: data.Title,
              });
            if (changed) router.refresh();
          }}
          tooltip={t("common.action.seo", undefined, "SEO")}
        />
        <FloatButton
          icon={<QuestionCircleOutlined />}
          onClick={() =>
            centerFaqModal.showList({
              TableKey: CenterOptions.Table.CenterSiteTemplatePage.key,
              CenterSiteTemplatePageId: data.Id,
            })
          }
          tooltip={t("center.siteTemplatePage.action.faq", undefined, "FAQ")}
        />
        <FloatButton
          icon={<ReloadOutlined />}
          onClick={async () => {
            const result = await Api.CenterSiteTemplatePage.resetPageCache({
              CenterSiteTemplatePageId: data.Id,
            });
            if (result.Success) router.refresh();
          }}
          tooltip={t(
            "center.siteTemplatePage.action.resetPageCache",
            undefined,
            "Reset Page Cache",
          )}
        />
      </FloatButton.Group>
    );
  return <></>;
};

export default TemplateDevTools;
